var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseDetailSimple',{attrs:{"input-attributes":_vm.inputAttributes,"leave-guard":_vm.leaveGuard,"query-selects":_vm.querySelects,"query-values":_vm.queryValues,"entity-type":"herSweden","locale-section":"pages.herSweden","field-section":"herSe"}})
}
var staticRenderFns = []

export { render, staticRenderFns }